export default __webpack_public_path__ + "static/media/Home-button.44302ada.svg";